export class Base {
	deserialize(input: any): this {
		return this;
	}
	serialize(): string {
		return '';
	}
}
